module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1Rhph"))).then(() => parcelRequire('d0iPb'));